import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import GrandAccessBanner from "app/pages/sales-intelligence/common-components/GrandAccessBanner/GrandAccessBanner";
import IntentSelectedTopicItem from "app/pages/sales-intelligence/pages/manage-signals/components/IntentSelectedTopicItem/IntentSelectedTopicItem";
import {
    IntentSelectedTopicItemWrapper,
    StyledGrandAccessWrapper,
    StyledSelectedTableBlock,
    StyledSelectedTableContainer,
} from "app/pages/sales-intelligence/pages/manage-signals/components/IntentSelectedTopicTable/styles";
import NoDataTopics from "app/pages/sales-intelligence/pages/manage-signals/components/NoDataTopics/NoDataTopics";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import intentTrackingService from "app/pages/sales-intelligence/services/tracking/intent/trackingService";
import { showIntentMoreTopicsHook } from "app/pages/sales-intelligence/sub-modules/intent/internalHooks/hooks";
import { setSelectedTopics } from "app/pages/sales-intelligence/sub-modules/intent/store/management/actions/actions";
import {
    selectIntentSelectedTopics,
    selectIsSelectedIntentTopicsOverLimit,
} from "app/pages/sales-intelligence/sub-modules/intent/store/management/selectors/selectors";
import type { Topic } from "app/pages/sales-intelligence/sub-modules/intent/types/common";
import { AssetsService } from "app/services/AssetsService";

const IntentSelectedTopicTable = () => {
    const dispatch = useDispatch();

    const selectedTopics: readonly Topic[] = useSelector(selectIntentSelectedTopics);
    const hasExtraTopic = useSelector(selectIsSelectedIntentTopicsOverLimit);
    const numIntentTopics = salesSettingsHelper.getNumIntentTopics();

    const ICON_IMAGE_PATH = AssetsService.assetUrl("/images/intent/hot_locked.svg");

    useEffect(() => {
        if (hasExtraTopic) {
            void intentTrackingService.trackSelectedTopicsHookAction();
        }
    }, [hasExtraTopic]);
    const onRemoveTopic = (selectedTopic: Topic) => {
        void intentTrackingService.trackRemoveTopicClickAction(selectedTopic);
        void dispatch(setSelectedTopics(selectedTopics.filter((topic: Topic) => topic.name !== selectedTopic.name)));
    };

    const onClickGrandAccess = () => {
        void intentTrackingService.trackContactUsClickAction("click gain access");
        showIntentMoreTopicsHook();
    };

    if (selectedTopics.length === 0) {
        return <NoDataTopics />;
    }

    return (
        <StyledSelectedTableBlock>
            <StyledSelectedTableContainer>
                {selectedTopics.map((topic, index) => (
                    <IntentSelectedTopicItemWrapper key={index}>
                        <IntentSelectedTopicItem
                            topic={topic}
                            onRemoveTopic={onRemoveTopic}
                            isExtraTopicItem={index + 1 > numIntentTopics}
                        />
                    </IntentSelectedTopicItemWrapper>
                ))}
            </StyledSelectedTableContainer>

            {hasExtraTopic ? (
                <StyledGrandAccessWrapper>
                    <GrandAccessBanner
                        title={translate("si.intent.management.banner.grand-access.title")}
                        description={translate("si.intent.management.banner.grand-access.description")}
                        iconImagePath={ICON_IMAGE_PATH}
                        button={
                            <IconButton
                                type={"trial"}
                                onClick={onClickGrandAccess}
                                iconName={"sparkles"}
                            >
                                {translate("si.intent.management.banner.grand-access.button")}
                            </IconButton>
                        }
                    />
                </StyledGrandAccessWrapper>
            ) : null}
        </StyledSelectedTableBlock>
    );
};

export default IntentSelectedTopicTable;
